export default __webpack_public_path__ + "static/media/Blue-Desktop-Icon.064d675a.png";